import { IconFa } from '@glow/ui-components'
import i18next from 'i18next'
import React from 'react'
import Container from '../primitives/Container'
import { H2 } from '../primitives/Headings'

export const Loading: React.FC<{
  loadingText?: string
}> = ({ loadingText }) => (
  <main>
    <Container center>
      <H2 textAlign>
        <IconFa icon="spinner" pulse size="2x" />
        <br />
        <br />
        {loadingText || i18next.t('loading')}
      </H2>
    </Container>
  </main>
)
